import { defineFeature } from "../../app/feature";
import { ReviewCasePage } from "./ReviewCasePage";
import { ReviewQueuePage } from "./ReviewQueuePage";

/** Review (task 4120.2; DESIGN-SPEC 24): a queue ordered by named signals, and one case with
 * everything a reviewer needs on one page. Owned by the learning-engine lane. */
export default defineFeature({
  id: "review",
  title: "Review queue",
  routes: [
    { path: "/review", Component: ReviewQueuePage },
    { path: "/review/:caseId", Component: ReviewCasePage },
  ],
  nav: { label: "Review queue", path: "/review", section: "Review Queue", order: 10 },
  permissions: ["engagement.read"],
});
